import { render, staticRenderFns } from "./InnerChatAttachments.vue?vue&type=template&id=80c1c8b0&scoped=true"
import script from "./InnerChatAttachments.vue?vue&type=script&lang=js"
export * from "./InnerChatAttachments.vue?vue&type=script&lang=js"
import style0 from "./InnerChatAttachments.vue?vue&type=style&index=0&id=80c1c8b0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80c1c8b0",
  null
  
)

export default component.exports